import "../styles/main.css";
import { Link } from "react-router-dom";

const Footer = () =>{
    return(
        <>
        <footer className="footer">
        <h2>
            Designed and Developed by
            <a className="name-tag h2" href="https://kumarharsh.netlify.app/"> harsh </a>
        </h2>
    </footer>
        </>
    )
}
export {Footer}